<template>
  <div class="home">
    <div class="home-content">
      <!-- <div class="home-content-banner">
        <div class="content-wrap">
          <div class="banner-title">
            <h1>开放链接，共创未来</h1>
            <div class="banner-title-botm"><span>开放、分享、互利、共赢</span></div>
          </div>
          <div class="home-content-banner-btn" @click="joinJT" @mouseover="mouseOver" @mouseleave="mouseLeave">
            <div :class="['bg-an',isMove ? 'moveStart' : 'moveEnd']"></div>
            <span :style="{color: isMove ? '#fff' : '#E60000','z-index': 1000}">快速对接</span><i :style="{color: isMove ? '#fff' : '#E60000','z-index': 1000}" class="iconfont iconxuanxianggengduojiantou"></i>
          </div>
        </div>
      </div> -->
      <div class="home-content-banner">
        <video @contextmenu.prevent id="bannerVideo" src="../../assets/images/newHome/banner.mp4" disablePictureInPicture="true" controlslist="nodownload nofullscreen noremoteplayback" autoplay loop muted></video>
        <div class="hover-top"></div>
        <div class="content-wrap">
          <div class="banner-title">
            <h1>开放链接，共创未来</h1>
            <div class="banner-title-botm"><span>开放、分享、互利、共赢</span></div>
          </div>
          <div class="home-content-banner-btn" @click="joinJT" @mouseover="mouseOver" @mouseleave="mouseLeave">
            <div :class="['bg-an',isMove ? 'moveStart' : 'moveEnd']"></div>
            <span :style="{color: isMove ? '#fff' : '#E60000','z-index': 1000}">快速对接</span><i :style="{color: isMove ? '#fff' : '#E60000','z-index': 1000}" class="iconfont iconxuanxianggengduojiantou"></i>
          </div>
        </div>
      </div>
      <div class="our-power">
        <div class="power-title">
          <span>我们的能力</span>
          <span class="line"></span>
          <span class="other">OUR CAPABILITIES</span>
        </div>
        <div class="power-box">
          <div class="power-pic" v-for="(item, index) in powerList" :key="index">
            <div><img style="width:138px;height:138px" :src="item.img" :alt="item.title"></div>
            <span class="power-pic-title">{{item.title}}</span>
          </div>
        </div>
      </div>
      <div class="register">
        <div class="power-title">
          <span>注册流程</span>
          <span class="line"></span>
          <span class="other">REGISTRATION PROCESS</span>
        </div>
        <div class="reg-content">
          <div class="reg-box" v-for="(item, index) in regList" :key="index" :style="{'background': `url(${item.img}) no-repeat center center`}">
            <div class="reg-desc">
              <span class="desc-title">{{item.title}}</span>
              <span class="red-line"></span>
              <span style="width:130px;font-sie:16px">{{item.title}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="content-tag">
        <div class="tag-desc">
          <span class="tag-top-title">开放共享  智慧融合 打造新物联</span>
        </div>
      </div>
      <div class="friend">
        <div class="power-title">
          <span>合作伙伴</span>
          <span class="line"></span>
          <span class="other">COOPERATION PARTNERS</span>
        </div>
        <!-- <div class="main-right-item logo">
          <div class="img-box" v-for="(item,index) in imgList" :key="index">
            <img :src="item.imgSrc" alt="logo">
          </div>
        </div> -->
        <div class="logo"></div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "./Footer"
import imgSrc1 from "@/assets/images/newHome/one.png"
import imgSrc2 from "@/assets/images/newHome/two.png"
import imgSrc3 from "@/assets/images/newHome/three.png"
import imgSrc4 from "@/assets/images/newHome/four.png"
import imgSrc5 from "@/assets/images/newHome/five.png"
import imgSrc6 from "@/assets/images/newHome/six.png"
import imgSrc7 from "@/assets/images/newHome/seven.png"
import imgSrc8 from "@/assets/images/newHome/eight.png"
// import imgSrc9 from "@/assets/images/newHome/nine.png"
import imgSrc10 from "@/assets/images/home/logo/PDD.png"
import imgSrc11 from "@/assets/images/home/logo/dangdang.png"
import imgSrc12 from "@/assets/images/home/logo/youzan.png"
import imgSrc13 from "@/assets/images/home/logo/suning.png"
import imgSrc14 from "@/assets/images/home/logo/haipaike.png"
import imgSrc15 from "@/assets/images/home/logo/YJ.png"
import imgSrc16 from "@/assets/images/home/logo/mengtui.png"
import imgSrc17 from "@/assets/images/home/logo/mogujie.png"
import imgSrc18 from "@/assets/images/home/logo/douyin.png"
import imgSrc19 from "@/assets/images/home/logo/kuaishou.png"
import imgSrc20 from "@/assets/images/home/logo/weidian.png"
import imgSrc21 from "@/assets/images/home/logo/inyoujinyou.png"
import imgSrc22 from "@/assets/images/home/logo/xiugou.png"
import imgSrc23 from "@/assets/images/home/logo/jiuye.png"
import imgSrc24 from "@/assets/images/home/logo/kuaidi100.png"
import imgSrc25 from "@/assets/images/home/logo/kuaidiwang.png"
import imgSrc26 from "@/assets/images/home/logo/zhuzhukuaidiyun.png"
import imgSrc27 from "@/assets/images/home/logo/yichadan.png"
import imgSrc28 from "@/assets/images/home/logo/kuaidiniao.png"
import debounce from 'lodash/debounce'
export default {
  components: { Footer },
  data() {
    return {
      powerList: [
        { img: imgSrc1, title: '标准化对接平台' },
        { img: imgSrc2, title: '多样化对接服务' },
        { img: imgSrc3, title: '高效自助测试平台' },
        { img: imgSrc4, title: '信息数据安全保障' }
      ],
      regList: [
        { img: imgSrc5, title: '注册用户', desc: '注册成为极兔开放平台用户' },
        { img: imgSrc6, title: '企业认证', desc: '填写企业信息获取全部接口权限' },
        { img: imgSrc7, title: '上线联调', desc: '发起申请联调，测试接口性能' },
        { img: imgSrc8, title: '发布上线', desc: '根据接口结果，进行接口上线' }
      ],
      imgList:[
        {imgSrc: imgSrc10},
        {imgSrc: imgSrc11},
        {imgSrc: imgSrc12},
        {imgSrc: imgSrc13},
        {imgSrc: imgSrc14},
        {imgSrc: imgSrc15},
        {imgSrc: imgSrc16},
        {imgSrc: imgSrc17},
        {imgSrc: imgSrc18},
        {imgSrc: imgSrc19},
        {imgSrc: imgSrc20},
        {imgSrc: imgSrc21},
        {imgSrc: imgSrc22},
        {imgSrc: imgSrc23},
        {imgSrc: imgSrc24},
        {imgSrc: imgSrc25},
        {imgSrc: imgSrc26},
        {imgSrc: imgSrc27},
        {imgSrc: imgSrc28},
      ],
      isMove: false
    }
  },
  methods: {
    joinJT() {
      window._hmt.push(['_trackCustomEvent', 'Docking']);
      this.$router.push({path:"/docking"})
    },
    mouseOver: debounce(function () {
      this.isMove = true
    }, 100),
    mouseLeave: debounce(function () {
      this.isMove = false
    }, 100),
  }
}
</script>

<style lang="scss" scoped>
.home{
    font-family: PingFangSC, PingFangSC-Semibold;
}
.content-wrap{
        // position: relative;
        width: 1200px;
        height: 100%;
        margin: 0 auto;
}
.hover-top {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0);
  position: absolute;
  top: 0;
}
.home-content-banner{
    min-width: 1200px;
    height: 650px;
    position: relative;
    // background:$theme-color url("../../assets/images/home/banner.gif") no-repeat center center;
    // background-size: 1920px 650px;
    video {
      height: 650px;
      width: 100%;
    }
    .banner-title {
      position: absolute;
      bottom: 264px;
      .banner-title-botm {
        padding-top: 10px;
      }
    }
    .home-content-banner-btn{
        z-index: 101;
        position: absolute;
        bottom: 153px;
        width: 243px;
        height: 55px;
        font-size: 18px;
        font-weight: 500;
        color: #E60000;
        line-height: 72px;
        cursor: pointer;
        display: flex;
        align-items: center;
        span{
            margin: 0 14px 0 40px
        }
        .iconfont{
            font-size: 19px;
        }
    }
}
@keyframes moveleave {
  from { width: 4px; }
  to { width: 180px; }
}
.bg-an {
  width: 4px;
  height: 55px;
  background-color: #E60000;
  position: absolute;
  z-index: 100;
}
.moveStart {
    animation-name: moveleave;
    animation-duration: 0.5s;
    animation-fill-mode:forwards;
}
@keyframes moveOver {
  from { width: 180px; }
  to { width: 4px; }
}
.moveEnd {
    animation-name: moveOver;
    animation-duration: 0.5s;
    animation-fill-mode:forwards;
}
.our-power {
  padding-top: 50px;
  height: 500px;
  .power-title {
    font-size: 30px;
    font-weight: 600;
    font-family: PingFangSC, PingFangSC-Semibold;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .line {
      width: 72px;
      height: 2px;
      background: #000000;
      text-align: center;
      margin: 20px 0;
    }
    span {
      display: block;
    }
    .other {
      font-size: 16px;
      font-family: Helvetica, Helvetica-Regular;
      font-weight: 400;
      color: #767a7e;
      letter-spacing: 0.6px;
    }
  }
  .power-box {
    display: flex;
    justify-content: space-evenly;
    width: 1200px;
    margin: 0 auto;
    padding-top: 80px;
    .power-pic {
      text-align: center;
      .power-pic-title {
        font-size: 22px;
        font-weight: 600;
      }
    }
  }
}
.register {
  height: 888px;
  background: #F8F8F9;
  padding-top: 50px;
  .power-title {
    font-size: 30px;
    font-weight: 600;
    font-family: PingFangSC, PingFangSC-Semibold;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .line {
      width: 72px;
      height: 2px;
      background: #000000;
      text-align: center;
      margin: 20px 0;
    }
    span {
      display: block;
    }
    .other {
      font-size: 16px;
      font-family: Helvetica, Helvetica-Regular;
      font-weight: 400;
      color: #767a7e;
      letter-spacing: 0.6px;
    }
  }
  .reg-content {
    width: 1200px;
    margin: 100px auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .reg-box {
      width: 525px;
      height: 256px;
      position: relative;
      margin-bottom: 20px;
      .reg-desc {
        position: absolute;
        right: 90px;
        top: 90px;
        .desc-title {
          width: 88px;
          height: 33px;
          font-size: 22px;
          font-family: PingFangSC, PingFangSC-Semibold;
          font-weight: 600;
          text-align: left;
          color: #000000;
          line-height: 33px;
        }
        .red-line {
          width: 39px;
          height: 2px;
          background: #e60000;
          margin: 10px 0 15px;
        }
        span {
          display: block;
        }
      }
    }
  }
}
.content-tag {
  min-width: 1200px;
  height: 150px;
  background:url("../../assets/images/newHome/long2.jpg") no-repeat center center;
  background-size: 1920px 150px;
  display: flex;
  align-items: center;
  .tag-desc {
    width: 1200px;
    margin: 0 auto;
    color: black;
    width: 1012px;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    line-height: 48px;
    letter-spacing: 12px;
    padding-top: 20px;
    .tag-top-title {
      font-family: PingFangSC, PingFangSC-Regular;
    }
    .tag-bot-title {
      font-family: Helvetica, Helvetica-Regular;
    }
    span {
      display: block;
    }
  }
}
.friend {
  padding-top: 50px;
  height: 650px;
  .power-title {
    font-size: 30px;
    font-weight: 600;
    font-family: PingFangSC, PingFangSC-Semibold;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .line {
      width: 72px;
      height: 2px;
      background: #000000;
      text-align: center;
      margin: 20px 0;
    }
    span {
      display: block;
    }
    .other {
      font-size: 16px;
      font-family: Helvetica, Helvetica-Regular;
      font-weight: 400;
      color: #767a7e;
      letter-spacing: 0.6px;
    }
  }
  .main-right-item.logo {
      width: 900px;
      margin: 20px auto;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      .img-box {
        width: 128px;
        height: 72px;
        margin: 0 20px 20px 0;
        img {
          width: 100%;
          height: 100%;
        }
        &:nth-child(6n){
          margin-right: 0;
        }
      }
  }
  .logo {
    min-width: 1250px;
    height: 480px;
    background:url("../../assets/images/newHome/friend.png") no-repeat center center;
    background-size: 1250px 480px;
  }
}

</style>